import React from "react";
import Option from "../Option";

class AttachmentsChecklist extends React.Component {
  render() {
    const { requirements } = this.props;

    if (!requirements.length) {
      return "There are no requirements for this service";
    }

    return requirements.map(requirement => (
      <Option checked={requirement.complete} key={requirement.type}>
        {requirement.message}
      </Option>
    ));
  }
}

export default AttachmentsChecklist;



// WEBPACK FOOTER //
// ./src/components/services/AttachmentsChecklist.js